import { Li } from 'meinian-package/src/baseComponent'
import DatePicker from 'meinian-package/src/component/datePicker'

export const CollectDate = ({ params, setParams }) => {
  return <Li className="item">
    <span className="label">采集时间</span>
    <DatePicker
      startTime={params.createdTimeStart}
      endTime={params.createdTimeEnd}
      noneText="不限"
      onChange={([createdTimeStart, createdTimeEnd]) => setParams(pre => ({ ...pre, createdTimeStart, createdTimeEnd }))}
    />
  </Li>
}
